import { useEffect, useState } from "react";
import { Card, Container } from "react-bootstrap";
import { useParams } from "react-router-dom";
import http from "services/httpClient";

export function ClientOverviewPage() {
  const { clientId } = useParams<{ clientId: string }>();
  const [devices, setDevices] = useState<any[]>([]);

  useEffect(() => {
    if (!clientId) return;
    (async () => {
      const res = await http.get(`/clients/${clientId}/devices`); // create endpoint if not existing
      setDevices(res.data || []);
    })();
  }, [clientId]);

  return (
    <Container fluid className="mt-3">
      <Card>
        <Card.Header>
          <h4 className="mb-0">Client Overview</h4>
        </Card.Header>
        <Card.Body>
          <div className="text-muted mb-2">Client ID: {clientId}</div>
          <div>Devices: {devices.length}</div>
          {/* later: summary cards, online/offline, latest readings, alarms */}
        </Card.Body>
      </Card>
    </Container>
  );
}

export default ClientOverviewPage;